import { defineType } from 'sanity';

export default defineType({
	name:   'faqCategory',
	title:  'FAQ Category',
	type:   'object',
	fields: [
		{
			name:  'title',
			title: 'Category Title',
			type:  'localizedText',
		},
		{
			name:  'faqs',
			title: 'FAQs',
			type:  'array',
			of:    [ { type: 'faqItem' } ],
		},
	],
	preview: {
		select: { title: 'title.en' },
		prepare({ title }) {
			return { title };
		},
	},
});